import {isAddressEmpty} from '../../../addressUtils';
import {BillingAddress, ShippingAddress, PickupAddress} from '../../../../../types/app.types';

const isBillingAddressEmpty = ({billingAddress}: {billingAddress: BillingAddress}) => {
  return isAddressEmpty({
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    addressLine1: billingAddress.addressLine1,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    addressLine2: billingAddress.addressLine2,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    city: billingAddress.city,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    country: billingAddress.country,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    subdivision: billingAddress.subdivision,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    zipCode: billingAddress.zipCode,
  });
};

export const shouldShowShipping = ({
  isPickupSelected,
  pickupAddress,
  shippingAddress,
}: {
  isPickupSelected: boolean;
  pickupAddress: PickupAddress;
  shippingAddress: ShippingAddress;
}) => {
  return isPickupSelected
    ? !isAddressEmpty({
        addressLine1: pickupAddress.addressLine,
        city: pickupAddress.city,
        country: pickupAddress.country,
        zipCode: pickupAddress.zipCode,
      })
    : !isAddressEmpty({
        // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
        addressLine1: shippingAddress.addressLine,
        // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
        addressLine2: shippingAddress.addressLine2,
        // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
        city: shippingAddress.city,
        // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
        country: shippingAddress.country,
        // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
        subdivision: shippingAddress.subdivision,
        // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
        zipCode: shippingAddress.zipCode,
      });
};

export const shouldShowBilling = ({billingAddress, totalPrice}: {billingAddress: BillingAddress; totalPrice: number}) =>
  !isBillingAddressEmpty({billingAddress}) && totalPrice !== 0;
